import React, { useEffect, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { authorizedRoutes, posRoutes, publicRoutes, userRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../feature-module/loader/loader";
import Error404 from "../feature-module/pages/errorpages/error404";
import Signin from "../feature-module/pages/login/signin";
import RemoteReponseToast from "../feature-module/components/remoteResponseToast";
import HeaderPos from "../InitialPage/Sidebar/HeaderPos";
import { checkModule } from "./authorization";
import Profile from "../feature-module/pages/profile";
import TokenRefresh from "./tokenRefresh";

const AllRoutes = () => {
  const navigate = useNavigate();
  const data = useSelector((state) => state.toggle_header);
  const token = useSelector((state) => state.token);
  const rolePermissions = useSelector((state) => state.rolePermissions);
  const tokenRefreshRef = useRef();

  useEffect(() => {
    if (token) {
      if (tokenRefreshRef.current) {
        tokenRefreshRef.current.validateToken(token);
      }
    }
  }, [rolePermissions, navigate]);

  const HeaderLayout = () => (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      <Sidebar />
      <Outlet />
      <Loader />
      <RemoteReponseToast />
    </div>
  );

  const Authpages = () => (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      <Loader />
      <RemoteReponseToast />
    </div>
  );

  const Pospages = () => (
    <div>
      <HeaderPos />
      <Outlet />
      <Loader />
      <RemoteReponseToast />
    </div>
  );

  return (
    <>
      <TokenRefresh ref={tokenRefreshRef} />
      <Routes>
        <Route path={"/"} element={token ? <HeaderLayout /> : <Authpages />}>
          {
            token
              ? <Route index element={<Profile />} key={1000} />
              : <Route index element={<Signin />} key={1000} />
          }
          {
            publicRoutes.map((route) => (
              <Route path={route.path} element={route.element} key={route.name} />
            ))
          }
          {
            token
              ? userRoutes.map((route) => (
                <Route path={route.path} element={route.element} key={route.name} />
              ))
              : null
          }
          {
            token
              ? authorizedRoutes.map((route) => (
                checkModule(rolePermissions, route.module, route.function) ?
                  <Route path={route.path} element={route.element} key={route.name} />
                  :
                  null
              ))
              : null
          }
        </Route>
        {
          token
            ?
            <Route path={"/"} element={<Pospages />}>
              {posRoutes.map((route) => (
                checkModule(rolePermissions, route.module, route.function) ?
                  <Route path={route.path} element={route.element} key={route.name} />
                  : null
              ))}
            </Route>
            : null
        }
        <Route path="*" element={<Error404 />} />
      </Routes>
    </>
  );
};
export default AllRoutes;
